import { useParams } from 'react-router-dom';
import QuestionnaireViewer from '../components/questionnaire/QuestionnaireViewer';
import { Container } from 'react-bootstrap';

export default function Questionnaire() {
  const { templateId } = useParams<{ templateId: string }>();

  return (
    <Container>
      <QuestionnaireViewer templateId={templateId || ''} />
    </Container>
  );
}
